import React from 'react';

import './empty-state.scss';

const EmptyState = (props) => <div className="empty-state">{props.message}</div>;

export default EmptyState;
